import React,{useEffect, useState} from "react"
import {
    AppBar, Avatar, Badge, Box, Divider, Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton, ListItemIcon, ListItemText, styled,
    Toolbar,
    Typography
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";

const Menu = ()=>{
    const [backbutton, setBackbutton] = React.useState(false);
    const location = useLocation().pathname;
    const [rightMneu , setRightMneu] = React.useState(false);
    const [name , setName] = React.useState("");
    const [image , setImage] = React.useState("");
    const data ={
        username : localStorage.getItem("username"),
    }
    axios.post("https://app.raumawood.com/api/get_userinfo.php",data)
        .then(respone => {
            setImage(respone.data[0].image);
            setName((respone.data[0].name));
        })
        .catch(error => console.log(error));
    useEffect(()=>{
        if (location !== "/")
            setBackbutton(true);
    },'');

    const navigate = useNavigate();
    const handlebottomSheet=(index)=>{
        if (index === 0){
            navigate("/");
            setRightMneu(false);
        }
        if (index === 1){
            navigate("/productlist");
            setRightMneu(false);
        }
        if (index === 2)
        {
            navigator.clipboard.writeText('https://raumawood.com/listprice.pdf');
            setRightMneu(false);
        }
        if (index === 3){
            navigator.clipboard.writeText('https://raumawood.com/listprice_chobplast.pdf');
            setRightMneu(false);
        }
        if (index === 4){
            navigator.clipboard.writeText('https://raumawood.com/catalog.pdf');
            setRightMneu(false);
        }
    }
    const list = () => (
        <Box
            sx={{textAlign:"center",width:"300px"}}
            role="presentation"
            onKeyDown={()=>{setRightMneu(false)}}>
            <AppBar
                position="static"
                sx={{backgroundColor:"inherit"}}>
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="default"
                        aria-label="menu"
                        onClick={()=>{setRightMneu(false)}}
                        sx={{ mr: 2 }}>
                        <CloseIcon />
                    </IconButton>
                    <div style={{textAlign:"right",color:"black",width:"100%"}}>تیزرو موتور</div>
                </Toolbar>
            </AppBar>
            <Avatar
                alt={name}
                src={image}
                sx={{ width: 73, height: 73,margin:"auto" , marginTop:3}}
            />
            <h5>{name} عزیز خوش آمدید </h5>
            <Divider />
            <List sx={{textAlign:"right"}}>
                {['صفحه اصلی','لیست محصولات','سفارشات من'].map((text, index) => (
                    <ListItem  key={text} disablePadding>
                        <ListItemButton
                            onClick={()=>{handlebottomSheet(index)}}>
                            <ListItemText sx={{textAlign:"right"}} primary={text} />
                            <ListItemIcon sx={{direction:"rtl"}}>
                                {index === 0 ? <HomeIcon /> : '' }
                                {index === 1 ? <BorderColorIcon sx={{color:"#092350"}} /> : '' }
                                {index === 2 ? <FileCopyIcon /> : '' }
                                {index === 3 ? <FileCopyIcon /> : '' }
                                {index === 4 ? <FileCopyIcon /> : '' }
                            </ListItemIcon>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
    return (
        <Box sx={{ flexGrow: 1 }}>

            <AppBar position="static" dir="rtl">
                <Toolbar sx={{backgroundColor:"#092350"}}>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 ,direction:"rtl",marginRight:0}}
                        onClick={()=>{setRightMneu(true)}}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1,textAlign:"center" }}>
                        شرکت تیزرو موتور شاهین
                    </Typography>
                    <IconButton
                        color="inherit"
                        aria-label="cart">
                        <Badge color="error" badgeContent={0}>
                            <ShoppingCartIcon />
                        </Badge>
                    </IconButton>
                    {backbutton ?
                        <IconButton
                            aria-label="back"
                            color="inherit"
                            onClick={() => window.history.back()}>
                            <ArrowBackIcon   />
                        </IconButton>
                        : ''}
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="right"
                open={rightMneu}
                onClose={()=>{setRightMneu(false)}}>
                {list()}
            </Drawer>
        </Box>
    )

}
export default Menu;